module.exports = __webpack_public_path__ + "images/billboard-604dcd37e1ea051b3570045ca0eb9aa3.svg";